import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "./services/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  userInfo: any = null;

  canActivate(): boolean {
    const token = localStorage.getItem("token");
    if (!token) {
      this.router.navigate(["/auth/signin"]);
      return false;
    }
    const userInfo: any = token;
    const payload = token.split(".")[1];
    this.userInfo = JSON.parse(atob(payload));
    if (this.userInfo?.realm_access?.roles.includes("super_admin")) {
      return true;
    }
    this.router.navigate(["/app"]);
    return false;
  }
}
